export const FETCH_SYSTEMS_REQUEST = 'MAV.FETCH_SYSTEMS_REQUEST';
export const FETCH_SYSTEMS_SUCCESS = 'MAV.FETCH_SYSTEMS_SUCCESS';
export const FETCH_SYSTEMS_FAILURE = 'MAV.FETCH_SYSTEMS_FAILURE';

export const FETCH_EVENTS_REQUEST = 'MAV.FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'MAV.FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'MAV.FETCH_EVENTS_FAILURE';

export const FETCH_SYSTEMS_WITH_EVENTS_REQUEST = 'MAV.FETCH_SYSTEMS_WITH_EVENTS_REQUEST';
export const FETCH_SYSTEMS_WITH_EVENTS_SUCCESS = 'MAV.FETCH_SYSTEMS_WITH_EVENTS_SUCCESS';
export const FETCH_SYSTEMS_WITH_EVENTS_FAILURE = 'MAV.FETCH_SYSTEMS_WITH_EVENTS_FAILURE';

export const FETCH_INVENTORY_REQUEST = 'MAV.FETCH_INVENTORY_REQUEST';
export const FETCH_INVENTORY_SUCCESS = 'MAV.FETCH_INVENTORY_SUCCESS';
export const FETCH_INVENTORY_FAILURE = 'MAV.FETCH_INVENTORY_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/MAV.ts